import type { FilterGroup } from '@bambi/api-client/schemas';

/**
 * `FilterGroup.filters` is an untyped JSON blob in the spec. The legacy
 * codegen called it `any`, which let callers index it without saying so;
 * hey-api calls it `unknown`. The field's own description says what it
 * holds — a flat map of filter name to value. The values stay `unknown`
 * because they are whatever JSON the filterset stored; callers narrow per
 * filter, which is what they already did when this was `any`.
 */
export type FilterGroupFilters = Record<string, unknown>;

export const filterGroupFilters = (
  filters: FilterGroup['filters']
): FilterGroupFilters => (filters ?? {}) as FilterGroupFilters;
